import { useContext, useState } from 'react'
import { AuthContext } from '../../../auth-context'

export function onlyMineStorageKey(user, list) {
  return `portal:onlyMine:${user.owner_id}:${user.id}:${list}`
}

export function useOnlyMine(list) {
  const { user } = useContext(AuthContext)
  const key = onlyMineStorageKey(user, list)
  const [preference, setPreference] = useState(() => ({ key, value: localStorage.getItem(key) === 'true' }))
  if (preference.key !== key) {
    setPreference({ key, value: localStorage.getItem(key) === 'true' })
  }
  const onlyMine = preference.key === key ? preference.value : localStorage.getItem(key) === 'true'
  const setOnlyMine = (value) => {
    setPreference({ key, value })
    localStorage.setItem(key, String(value))
  }
  return [onlyMine, setOnlyMine]
}

export function isCreatedByMe(record, user) {
  return Number(record.created_manager_id ?? user.owner_id) === Number(user.id)
}

export function isAssignedToCoach(account, coachID) {
  return coachID === '' || (account.trainers || []).some((id) => Number(id) === Number(coachID))
}

export function resourceCreatorName(record, user) {
  // Default to portal owner if NULL created_manager_id
  const coachID = record.created_manager_id ?? user.owner_id
  if (coachID == null) return 'Unknown coach'
  const matchesID = (coach) => Number(coach.id) === Number(coachID)
  const coach = user.team?.find(matchesID) || user.team_inactive?.find(matchesID)
  return coach?.name || 'Unknown coach'
}
